import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-submit-confirm-dialog',
  templateUrl: 'submit-confirm-dialog.html'
})
export class SubmitConfirmDialog {

  constructor(
    public dialogRef: MatDialogRef<SubmitConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
